import { Suspense } from 'react'

import { LazyRouteDefinition, createRouteViewSwitch, lazyLoadComponent } from '../../util-routing'
import { LoadingScreen } from './components/LoadingScreen'
import { InsiderView, InsiderViewParam } from './constants'

const { loader, action, ViewSwitch } = createRouteViewSwitch({
  defaultView: InsiderView.Index,
  viewParam: InsiderViewParam.View,
  views: {
    '': {
      Component: lazyLoadComponent({
        chunkName: 'insider-index',
        load: () => import(/* webpackChunkName: "insider-index" */ './routes/Index'),
      }),
    },
    [InsiderView.Managers]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-managers',
        load: () => import(/* webpackChunkName: "insider-managers" */ './routes/Managers'),
      }),
    },
    [InsiderView.ManagerDetails]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-manager-details',
        load: () => import(/* webpackChunkName: "insider-manager-details" */ './routes/ManagerDetails'),
      }),
    },
    [InsiderView.ManagerHoldings]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-manager-holdings',
        load: () => import(/* webpackChunkName: "insider-manager-holdings" */ './routes/ManagerHoldings'),
      }),
    },
    [InsiderView.Funds]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-funds',
        load: () => import(/* webpackChunkName: "insider-funds" */ './routes/Funds'),
      }),
    },
    [InsiderView.FundDetails]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-fund-details',
        load: () => import(/* webpackChunkName: "insider-fund-details" */ './routes/FundDetails'),
      }),
    },
    [InsiderView.FundHoldings]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-fund-holdings',
        load: () => import(/* webpackChunkName: "insider-fund-holdings" */ './routes/FundHoldings'),
      }),
    },
    [InsiderView.NotFound]: {
      Component: lazyLoadComponent({
        chunkName: 'insider-not-found',
        load: () => import(/* webpackChunkName: "insider-not-found" */ './routes/NotFound'),
      }),
    },
  },
})

export const insiderTradingModule: LazyRouteDefinition[] = [
  {
    path: '/insidertrading.ashx',
    loader,
    action,
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <ViewSwitch />
      </Suspense>
    ),
  },
]
